/** Calculate whether a widget should be visible or not. */
export const isWidgetVisible = (dataValueByPath: any) => {
  if (dataValueByPath === undefined || dataValueByPath === null) return false;
  if (Array.isArray(dataValueByPath) && dataValueByPath.length === 0) {
    return false;
  }
  return true;
};
